import {
  InMemoryHeader,
  InMemoryString,
  InMemoryBoolean,
  InMemoryDate
} from "pbas-vue-components";
import { translate2 } from '../trans2'
import { translate } from '../trans'
import store from '@/store'
import BooleanInjectableComponent from '../components/BooleanInjectableComponent';
import { i18n } from '@/plugins/i18n';



const BenefitHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("Id"),
    sortable: false,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false
  }),
  new InMemoryHeader({
    title: "globals.benefit",
    type: new InMemoryString("CoverageIdentity/Current/Translations[]/Name", {
      getString: (item) => translate2(item.CoverageIdentity.Current, "Name"),
      getHtml: (item, type) => {
        function formatDate(dateString) {
          if (dateString === undefined || dateString === null) {
            return "";
          }
          const [date, time] = dateString.split("T");
          const [year, month, day] = date.split("-");
          return `${year}-${month}-${day}`;
        }
        if (item.CoverageIdentity.Current.HasCOB && item.COB !== null && item.COB!== undefined && item.COB.IsRemoved !== true) {
          const lang = store.getters['common/language'];
          const insuranceCarrier = item.COB.InsuranceCarrier !==null && item.COB.InsuranceCarrier!== undefined?item.COB.InsuranceCarrier:null;
          const policy = item.COB.PolicyNumber !==null && item.COB.PolicyNumber!== undefined?item.COB.PolicyNumber:null;
          const date = item.COB.EffectiveDate !==null && item.COB.EffectiveDate!== undefined?formatDate(item.COB.EffectiveDate):null;
          const coverageStatus = item.COB.CoverageStatus !== null && item.COB.CoverageStatus !== undefined?translate(item.COB.CoverageStatus, lang.language):null;
          console.log(insuranceCarrier, policy, date), coverageStatus;
          let tooltip = date;
          if (insuranceCarrier!==null) {
            tooltip+=", "+insuranceCarrier
          }
          if (policy!==null) {
            tooltip+=" ("+policy+")"
          }
          if (item.COB.HealthCobTypes!==null && item.COB.HealthCobTypes!==undefined) {
            tooltip+=", "+item.COB.HealthCobTypes.join(", ");
          }
          if (coverageStatus!==null) {
            tooltip+=", "+coverageStatus;
          }
          return type.getString(item, type) +`&nbsp;<span class="tooltip" style="background-color:#f54284;padding:3px 6px;color:white;border-radius:3px;">
            COB
              <span class="tooltiptext">`+tooltip+`</span>
          </span>`
        }
        return type.getString(item, type);
      }
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true
  }),
  new InMemoryHeader({
    title: "globals.coverage",
    type: new InMemoryString("Coverage", {
      getString: item => {
        console.log(item);
        if (!item) return "";
        if (item.IsWaived) {
          return i18n.t("headers.benefits.waived");
        }
        let res = [];
        if (item.CoverageIdentity.Current.HasCoverageChoice) {
          const lang = store.getters['common/language']
          if (item.NoOfDependants !== null && item.NoOfDependants !== undefined && item.CoverageStatus.Name !== "Single"
            && item.CoverageStatus.Name !== "Couple") {
            res.push(translate(item.CoverageStatus, lang.language)+`(${item.NoOfDependants})`);
          } else {
            res.push(translate(item.CoverageStatus, lang.language));
          }
        } 
        if (item.CoverageIdentity.Current.HasVolumeChoice) {
          let a = parseFloat(item.Volume);
          if (!isNaN(a)){
            var formatter = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
            });
            res.push(formatter.format(item.Volume));
          }
        }
        return res.join(", ");
      }
    }),
    sortable: true,
    visible: true,
    searchable: true,
    allowVisibilityChange: true,
  })
];
export default BenefitHeaders;